// extracted by mini-css-extract-plugin
export default {"columns":"Students_columns__-NYCt"};